var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 79,
    viewBox: "0 0 98 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_86_2878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4867 33.9753C27.0031 28.4704 23.4247 24.3566 22.5066 24.2199C24.9909 26.4005 24.9807 34.4108 24.3354 37.111C23.6901 39.8111 20.3555 42.8597 20.3555 47.2148C21.1085 55.2282 31.4792 58.581 35.523 58.3638C30.7899 56.5521 27.5267 51.9764 26.4867 49.915C26.3021 50.9084 26.6589 52.9809 27.3473 54.7927C19.8173 50.4376 21.4165 45.5599 22.5066 43.2952C23.3671 47.6155 24.5146 49.102 24.9807 49.3052C25.0525 48.6084 25.2604 46.8838 25.5186 45.5599C28.5306 49.8278 31.435 47.8245 33.694 47.2148C33.251 47.6148 29.2836 49.915 29.2836 49.915C29.2836 49.915 34.2319 52.4409 36.706 53.399V49.3052C39.3033 48.7206 45.1504 47.2148 45.9021 44.8453C51.5497 53.399 56.9293 54.8798 60.0489 51.9183C63.1684 48.9568 67.2561 49.4794 68.1167 51.3957C68.9773 53.3119 65.1668 56.8082 63.5987 58.3638C70.3546 57.2853 77.5732 44.3601 77.5732 42.6181C77.0354 43.0536 75.9694 44.0791 74.3558 44.0791C75.324 35.3689 70.4833 32.4075 65.7502 29.6202C61.017 26.833 62.7496 22.3673 62.4155 20.91C60.0489 26.5717 63.4912 29.3589 65.7502 31.7978C68.0091 34.2366 69.6227 38.5046 65.7502 42.8597C63.9725 41.7971 53.7152 40.6245 51.7519 40.6245C48.6083 40.3554 44.2076 41.8622 45.1504 34.5457C40.4364 38.3214 40.3421 41.2769 36.706 42.8597C35.4151 37.7207 33.5864 36.0658 31.435 36.0658C33.694 38.1562 33.5864 44.6017 30.0366 44.0791C26.4867 43.5565 25.8413 40.8564 26.4867 33.9753Z",
    fill: "url(#paint0_linear_86_2878)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_2878",
    x: 0.355469,
    y: 0.910034,
    width: 97.2168,
    height: 77.4637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.360784 0 0 0 0 0.211765 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_2878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_2878",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_2878",
    x1: 39.9778,
    y1: 9.59722,
    x2: 74.8838,
    y2: 60.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895695,
    stopColor: "#FC5C18"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire1);
export default __webpack_public_path__ + "static/media/fire1.96a84bc1.svg";
export { ForwardRef as ReactComponent };